import MyCard from './MyCard';
import React from 'react';
import { KuposDataNotFound } from '../../../../common';

function MyCards(props) {
  return (
    <div className="my-bip-container env-impact-container">
      <div className="bip-top-strip">
        <div className="bip-icon-top back-arrow" onClick={() => props.setSelectedItem(null)}>
          <img style={{ marginLeft: '2%' }} src="/static/images/back_arrow_bip.png" />
        </div>

        <div>
          <div className="font13 center-text">
            <span>
              <span className="bold-text bip-top-strip-heading">{props.t('PROFILE.MY_CARDS')}</span>
            </span>
          </div>
        </div>
        <div className="my-cards-right-icon">
          {props.myCards.length < 2 && props.myCards.length > 0 ? (
            <img onClick={() => props.setShowCardAddInfoModal(true)} src="/static/images/add_card.svg" />
          ) : null}
        </div>
      </div>

      <div className="my-cards-sub-body">
        {props.myCards && props.myCards.length > 0 ? (
          props.myCards.map((val, key) => (
            <MyCard
              t={props.t}
              val={val}
              key={key}
              cardTypes={props.cardTypes}
              setShowDeleteCard={props.setShowDeleteCard}
              setSelectedItemForDeletion={props.setSelectedItemForDeletion}
            />
          ))
        ) : (
          <KuposDataNotFound
            icon={'/static/images/no-cards.svg'}
            title={props.t('TRANSLATIONS.NO_CARDS_TITLE')}
            subTitle={props.t('TRANSLATIONS.NO_CARDS_DESC')}
            infoText={props.t('TRANSLATIONS.NO_CARDS_INFO_HINT')}
            onInfoClick={() => {
              props.setShowCardAddInfoModal(true);
            }}
            operator={props.operator}
          />
        )}
      </div>
    </div>
  );
}

export default MyCards;



// WEBPACK FOOTER //
// ./src/features/themes/my-account/MainTabsBodyMyAccount/components/MyCards.js